import { useMutation, useQueryClient } from '@tanstack/react-query';
import { markNotificationRead } from '@/services/notifications/mark-notification-read';
import { NOTIFICATIONS_QUERY_KEY } from '@/hooks/queries/use-get-notifications';
import { useOrgStore } from '@/stores/org-store';

export const useMarkNotificationRead = () => {
  const queryClient = useQueryClient();
  const { currentOrg } = useOrgStore();
  const orgId = currentOrg?.orgid;

  return useMutation({
    mutationFn: (id: string) => {
      if (!orgId) throw new Error('No org ID');
      return markNotificationRead(orgId, id);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [NOTIFICATIONS_QUERY_KEY] });
    },
  });
};
